var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-overlay',{attrs:{"value":_vm.showWarning,"icon":_vm.warningIcon,"type":"warning"},on:{"input":_vm.update}},[[_c('div',[_c('div',{staticClass:"text-h5 compact-h5 font-weight-bold"},[_vm._v(_vm._s(_vm.warningTitle))]),_c('div',{staticClass:"text-body-2 mt-2 mb-2"},[_vm._v(_vm._s(_vm.warningMessage))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }